import React from 'react';

interface WageAtlasLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const WageAtlasLogo: React.FC<WageAtlasLogoProps> = ({ 
  className = '', 
  showText = true, 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Logomark - map pin with ascending wage bars */}
      <img
        src="/logo-icon.png"
        alt="WageAtlas logo"
        width={40}
        height={40}
        loading="eager"
        decoding="async"
        className={`${sizeClasses[size]} object-contain`}
      />

      {/* Wordmark */}
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-bold font-inter ${textSizeClasses[size]}`}>
            <span className="text-primary">Wage</span>
            <span className="text-foreground">Atlas</span>
          </span>
          {size !== 'sm' && (
            <span className="text-xs text-muted-foreground font-medium tracking-wider">
              Wages, mapped.
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default WageAtlasLogo;
